(function () {
  'use strict';

  // ── Mobile nav ────────────────────────────────────────────────────────────
  var hamburger = document.getElementById('hamburger');
  var mobileNav = document.getElementById('mobile-nav');
  var mobileClose = document.getElementById('mobile-nav-close');
  var mobileOverlay = document.getElementById('mobile-nav-overlay');

  function openNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
  }
  function closeNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    document.body.style.overflow = '';
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
  }

  if (hamburger) hamburger.addEventListener('click', openNav);
  if (mobileClose) mobileClose.addEventListener('click', closeNav);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeNav);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNav(); });

  // ── Quantity +/- ──────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target;
    if (btn.classList.contains('qty-minus') || btn.classList.contains('qty-plus')) {
      var inp = btn.parentElement.querySelector('input[type="number"]');
      if (!inp) return;
      var val = parseInt(inp.value) || 1;
      var min = parseInt(inp.min) || 0;
      if (btn.classList.contains('qty-minus')) {
        inp.value = Math.max(min, val - 1);
      } else {
        inp.value = val + 1;
      }
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // ── Gallery thumbnails (old selector) ────────────────────────────────────
  document.querySelectorAll('.prod-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.querySelector('img').src;
      var mainImg = document.querySelector('.prod-gallery__main img');
      if (mainImg) mainImg.src = src;
      document.querySelectorAll('.prod-gallery__thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  // ── New PDP gallery thumbs ────────────────────────────────────────────────
  document.querySelectorAll('.pdp-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.dataset.src;
      var mainImg = document.getElementById('pdp-main-img');
      if (mainImg && src) mainImg.src = src;
      document.querySelectorAll('.pdp-thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  // ── Variant chip selector ─────────────────────────────────────────────────
  var chips = document.querySelectorAll('.pdp-chip');
  if (chips.length && window.productVariants) {
    var selectedOpts = {};

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var pos = chip.dataset.pos;
        var val = chip.dataset.value;
        selectedOpts[pos] = val;

        document.querySelectorAll('.pdp-option__chips[data-option="' + pos + '"] .pdp-chip').forEach(function (c) {
          c.classList.remove('active');
        });
        chip.classList.add('active');

        var label = document.getElementById('selected-' + pos);
        if (label) label.textContent = val;

        var numOpts = document.querySelectorAll('.pdp-option__chips').length;
        if (Object.keys(selectedOpts).length === numOpts) {
          var matched = window.productVariants.find(function (v) {
            return v.options.every(function (o, i) {
              return selectedOpts[String(i + 1)] === o;
            });
          });
          if (matched) {
            var idIn = document.querySelector('input[name="id"]');
            if (idIn) idIn.value = matched.id;
            var priceEl = document.getElementById('product-price');
            if (priceEl && matched.price) {
              priceEl.textContent = '$' + (matched.price / 100).toFixed(2);
            }
          }
        }
      });

      if (chip.classList.contains('active')) {
        selectedOpts[chip.dataset.pos] = chip.dataset.value;
      }
    });
  }

  // ── Variant selector (dropdown fallback) ─────────────────────────────────
  var selects = document.querySelectorAll('.variant-select');
  if (selects.length && window.productVariants) {
    function getVariant() {
      var opts = Array.from(selects).map(function (s) { return s.value; });
      return window.productVariants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var v = getVariant();
        if (!v) return;
        var idIn = document.querySelector('input[name="id"]');
        if (idIn) idIn.value = v.id;
      });
    });
  }

  // ── Cart item remove ──────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-remove]');
    if (!btn) return;
    e.preventDefault();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: btn.dataset.remove, quantity: 0 })
    }).then(function () { window.location.reload(); });
  });

})();